/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WarehouseDtoContactInfo } from './WarehouseDtoContactInfo';
import {
    WarehouseDtoContactInfoFromJSON,
    WarehouseDtoContactInfoFromJSONTyped,
    WarehouseDtoContactInfoToJSON,
} from './WarehouseDtoContactInfo';
import type { WarehouseServiceAreaDto } from './WarehouseServiceAreaDto';
import {
    WarehouseServiceAreaDtoFromJSON,
    WarehouseServiceAreaDtoFromJSONTyped,
    WarehouseServiceAreaDtoToJSON,
} from './WarehouseServiceAreaDto';

/**
 * 
 * @export
 * @interface WarehouseDto
 */
export interface WarehouseDto {
    /**
     * Warehouse ID
     * @type {number}
     * @memberof WarehouseDto
     */
    id: number;
    /**
     * Warehouse name
     * @type {string}
     * @memberof WarehouseDto
     */
    name: string;
    /**
     * Country code where warehouse is located
     * @type {string}
     * @memberof WarehouseDto
     */
    countryCode: string;
    /**
     * Supplier organization ID
     * @type {number}
     * @memberof WarehouseDto
     */
    organizationId: number;
    /**
     * Contact info ID
     * @type {number}
     * @memberof WarehouseDto
     */
    contactInfoId: number | null;
    /**
     * 
     * @type {WarehouseDtoContactInfo}
     * @memberof WarehouseDto
     */
    contactInfo?: WarehouseDtoContactInfo;
    /**
     * Whether warehouse is active
     * @type {boolean}
     * @memberof WarehouseDto
     */
    isActive: boolean;
    /**
     * Service areas this warehouse serves
     * @type {Array<WarehouseServiceAreaDto>}
     * @memberof WarehouseDto
     */
    serviceAreas: Array<WarehouseServiceAreaDto>;
    /**
     * Number of catalog items in this warehouse
     * @type {number}
     * @memberof WarehouseDto
     */
    catalogItemCount?: number;
    /**
     * Whether warehouse has a product catalog
     * @type {boolean}
     * @memberof WarehouseDto
     */
    hasCatalog?: boolean;
    /**
     * Whether warehouse has service areas outside allowed operating areas
     * @type {boolean}
     * @memberof WarehouseDto
     */
    hasInvalidServiceAreas?: boolean;
    /**
     * List of service area IDs that are outside allowed operating areas
     * @type {Array<number>}
     * @memberof WarehouseDto
     */
    invalidServiceAreaIds?: Array<number>;
    /**
     * Timestamp created at
     * @type {Date}
     * @memberof WarehouseDto
     */
    createdAt: Date;
    /**
     * Timestamp updated at
     * @type {Date}
     * @memberof WarehouseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the WarehouseDto interface.
 */
export function instanceOfWarehouseDto(value: object): value is WarehouseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('contactInfoId' in value) || value['contactInfoId'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('serviceAreas' in value) || value['serviceAreas'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function WarehouseDtoFromJSON(json: any): WarehouseDto {
    return WarehouseDtoFromJSONTyped(json, false);
}

export function WarehouseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'countryCode': json['countryCode'],
        'organizationId': json['organizationId'],
        'contactInfoId': json['contactInfoId'],
        'contactInfo': json['contactInfo'] == null ? undefined : WarehouseDtoContactInfoFromJSON(json['contactInfo']),
        'isActive': json['isActive'],
        'serviceAreas': ((json['serviceAreas'] as Array<any>).map(WarehouseServiceAreaDtoFromJSON)),
        'catalogItemCount': json['catalogItemCount'] == null ? undefined : json['catalogItemCount'],
        'hasCatalog': json['hasCatalog'] == null ? undefined : json['hasCatalog'],
        'hasInvalidServiceAreas': json['hasInvalidServiceAreas'] == null ? undefined : json['hasInvalidServiceAreas'],
        'invalidServiceAreaIds': json['invalidServiceAreaIds'] == null ? undefined : json['invalidServiceAreaIds'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function WarehouseDtoToJSON(value?: WarehouseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'countryCode': value['countryCode'],
        'organizationId': value['organizationId'],
        'contactInfoId': value['contactInfoId'],
        'contactInfo': WarehouseDtoContactInfoToJSON(value['contactInfo']),
        'isActive': value['isActive'],
        'serviceAreas': ((value['serviceAreas'] as Array<any>).map(WarehouseServiceAreaDtoToJSON)),
        'catalogItemCount': value['catalogItemCount'],
        'hasCatalog': value['hasCatalog'],
        'hasInvalidServiceAreas': value['hasInvalidServiceAreas'],
        'invalidServiceAreaIds': value['invalidServiceAreaIds'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

